// Thin wrappers around /api/projects endpoints + /api/auth/switch-project.
import { fetchData } from '../fetchapi/fetchapi';

export async function listProjects() {
  const res = await fetchData('projects');
  return res.projects || [];
}

export async function createProject({ name, slug, description, org_slug }) {
  return fetchData('projects', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, slug, description, org_slug }),
  });
}

export async function deleteProject(slug) {
  return fetchData(`projects/${encodeURIComponent(slug)}`, { method: 'DELETE' });
}
